import { Component, Input, SimpleChanges } from '@angular/core';
import { ChartData } from '../../../../../shared/models/depth-data';

@Component({
  selector: 'app-depth-detail-mobile',
  templateUrl: './depth-detail-mobile.component.html',
  styleUrl: './depth-detail-mobile.component.scss'
})
export class DepthDetailMobileComponent {
  @Input() depth_detail: ChartData | null = null; 
  
  ngOnChanges(changes: SimpleChanges): void { 
    if (changes['depth_detail'] && this.depth_detail) { 
      this.sortDataByDate(); 
    } 
  } 
  
  sortDataByDate() { 
    if (this.depth_detail && this.depth_detail.result) { 
      this.depth_detail.result.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()); 
    } 
  }
}
